// Barra lateral esquerda: as janelas de análise do Tibia que acompanham a hunt idle.
import { Widget } from './Widget';

const SKIN = '/assets/interface/images/skin/classic';

export interface HuntInfo {
  cave: string; floor: number; elapsed: string; offlineLeft: string;
  xp: number; xpHour: number; loot: number; waste: number; balanceHour?: number; kills: number; chestIn: string;
  /** parte do loot em gold (o resto é o valor de venda dos itens) */
  lootGold?: number;
}
export interface LootLine { name: string; /** id do item (para o "Não pegar") */ id?: number; /** já está na lista de não pegar */ skip?: boolean; rarity: 'comum' | 'raro' | 'epico' | 'lendario'; count: number; /** valor de uma unidade (cor do nome, como o destaque de loot do Tibia) */ value?: number }
/** destaque de loot do Tibia pelo valor: cinza, verde, azul, roxo e dourado */
const tier = (v = 0) => (v >= 1_000_000 ? 'v5' : v >= 100_000 ? 'v4' : v >= 10_000 ? 'v3' : v >= 1_000 ? 'v2' : v >= 100 ? 'v1' : 'v0');

const fmt = (n: number) => n.toLocaleString('pt-BR');
const KV = (k: string, v: string | number, cls = '') => <div class="kv"><span>{k}</span><b class={cls}>{v}</b></div>;

export function LeftPanel(props: { hunt: HuntInfo | null; loot: LootLine[]; bestiary: Array<{ name: string; kills: number; next: number }>; prey: string[]; onPrey?: () => void; onLootMenu?: (l: LootLine, x: number, y: number) => void }) {
  const h = props.hunt;
  return (
    <aside class="side left">
      <Widget id="hunt" title="Hunt Analyser" icon={`${SKIN}/icon-huntingsessionanalyser-widget.png`}>
        {h ? (
          <div class="kvs">
            <div class="ha-head"><b>{h.cave}</b><span>{h.floor ? `andar ${h.floor} · ` : ''}{h.elapsed}</span></div>
            {KV('XP Gain', fmt(h.xp), 'ha-xp')}
            {KV('XP/h', fmt(h.xpHour), 'ha-xph')}
            {KV('Loot', fmt(h.loot) + ' gp', 'ha-loot')}
            {h.lootGold !== undefined && <div class="kv ha-sub"><span>gold {fmt(h.lootGold)} · itens {fmt(Math.max(0, h.loot - h.lootGold))}</span></div>}
            {KV('Supplies', fmt(h.waste) + ' gp', 'ha-waste')}
            {KV('Balance', fmt(h.loot - h.waste) + ' gp', h.loot - h.waste >= 0 ? 'ha-pos' : 'ha-neg')}
            {h.balanceHour !== undefined && KV('Balance/h', fmt(h.balanceHour) + ' gp', h.balanceHour >= 0 ? 'ha-pos' : 'ha-neg')}
            {KV('Monstros mortos', fmt(h.kills), 'ha-kills')}
            {h.offlineLeft !== '—' && KV('Offline restante', h.offlineLeft)}
            {h.chestIn !== '—' && KV('Baú', h.chestIn)}
          </div>
        ) : <p class="empty">Nenhuma hunt ativa. Use o botão Hunts para escolher uma cave.</p>}
      </Widget>
      <Widget id="loot" title="Loot Tracker" icon={`${SKIN}/icon-loottracker-widget.png`}>
        {props.loot.length ? (
          <ul class="loot">{props.loot.map((l, i) => <li key={i} class={'lt-' + tier(l.value) + (l.rarity !== 'comum' ? ' r-' + l.rarity : '') + (l.skip ? ' lt-skip' : '')}
            title={l.skip ? 'Não está sendo coletado (clique para voltar a pegar)' : 'Clique (ou botão direito) para não pegar mais este item'}
            onClick={(e) => props.onLootMenu?.(l, e.clientX, e.clientY)} onContextMenu={(e) => { e.preventDefault(); props.onLootMenu?.(l, e.clientX, e.clientY); }}><i class="lt-n">{l.count}x</i> {l.name}{l.rarity !== 'comum' ? <em> {l.rarity === 'raro' ? 'raro' : l.rarity === 'epico' ? 'épico' : 'lendário'}</em> : null}</li>)}</ul>
        ) : <p class="empty">Os drops da hunt aparecem aqui.</p>}
      </Widget>
      <Widget id="bestiary" title="Bestiary Tracker" icon={`${SKIN}/icon-bestiarytracker-widget.png`}>
        {props.bestiary.length ? props.bestiary.map((b) => (
          <div key={b.name} class="bt"><span>{b.name}</span><span>{fmt(b.kills)} / {fmt(b.next)}</span>
            <div class="sk-bar green"><i style={{ width: Math.min(100, (b.kills / b.next) * 100) + '%' }} /></div></div>
        )) : <p class="empty">Criaturas acompanhadas no bestiário.</p>}
      </Widget>
      <Widget id="prey" title="Prey" icon={`${SKIN}/icon-preydialogue.png`}>
        <div class="prey-mini" onClick={props.onPrey} title="Abrir o Prey">
          {props.prey.length ? props.prey.map((p) => <div key={p} class="kv"><span>{p}</span></div>) : <p class="empty">Nenhum prey ativo. Clique para escolher.</p>}
        </div>
      </Widget>
    </aside>
  );
}
